import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-9174b3bc")

_pushScopeId("data-v-9174b3bc")
const _hoisted_1 = { class: "slide-thumbnails" }
const _hoisted_2 = { class: "return-button" }
const _hoisted_3 = { class: "slide-thumbnails-content" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_IconArrowCircleLeft = _resolveComponent("IconArrowCircleLeft")
  const _component_ThumbnailSlide = _resolveComponent("ThumbnailSlide")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_IconArrowCircleLeft, {
        class: "icon",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.close()))
      })
    ]),
    _createVNode("div", _hoisted_3, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.slides, (slide, index) => {
        return (_openBlock(), _createBlock("div", {
          class: ["thumbnail", { 'active': index === _ctx.slideIndex }],
          key: slide.id,
          onClick: ($event: any) => (_ctx.turnSlideToIndex(index))
        }, [
          _createVNode(_component_ThumbnailSlide, {
            slide: slide,
            size: 150
          }, null, 8, ["slide"])
        ], 10, ["onClick"]))
      }), 128))
    ])
  ]))
})